// extracted by mini-css-extract-plugin
module.exports = {"tag":"JobStatusTag_tag__aG7OB","default":"JobStatusTag_default__yBBLp","new":"JobStatusTag_new__HGOyY"};